import React from 'react';

import clsx from 'clsx';

import { useBrand } from '@atc/brand';

import { ColoredBackground } from 'reaxl';

import SearchLink from '@/components/SearchLink';

// wrapStyle support super small device, so that the user has to side scroll
const wrapStyle = {
    overflowX: 'auto',
};

export function BuildAndPricePaginationContainer() {

    const { brands, isBrand } = useBrand();

    return (
        <>
            <ColoredBackground
                className="container-fluid"
                style={wrapStyle}
            >
                <div
                    className={clsx('container', {
                        'margin-top-4': isBrand(brands.KBB_BRAND),
                    })}
                >
                    <div
                        className="align-items-center display-flex justify-content-between"
                    >
                        <SearchLink />
                    </div>
                </div>
            </ColoredBackground>
            <hr className="margin-0" />
        </>
    );
}

export default BuildAndPricePaginationContainer;
